import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import Box from '@mui/material/Box';

import BackButton from '@ts-core/components/BackButton';
import { DEFAULT_EXERCISE_TYPE } from '@ts-core/utils/Constants';

import { useSubjectStats } from '@ts-core/modules/subjects/hooks';

import { SubjectWithStats, SubjectExerciseWithStats } from '../../types/stats';
import { subjectWithStatsFragment } from '../../graphql/fragments';

import SubjectStatsTable from '../../components/SubjectStatsTable';

const SubjectStatsPage = () => {
  const history = useHistory();
  const { courseId, subjectId } = useParams<{ courseId: string; subjectId: string }>();
  const { loading, subject, error } = useSubjectStats<SubjectWithStats>({ fragment: subjectWithStatsFragment, courseId, subjectId });

  const handleExerciseClick = useCallback(
    (exercise: SubjectExerciseWithStats) => {
      history.push(`/${courseId}/subjects/${subjectId}/exercise-view/${exercise.type || DEFAULT_EXERCISE_TYPE}/${exercise.id}`);
    },
    [history, courseId, subjectId]
  );

  return (
    <Box>
      <BackButton title={subject?.name} subtitle="Todos los temas" href={`/${courseId}/stats`} />
      <Box mt={2}>
        <SubjectStatsTable subject={subject} loading={loading} error={error} onClickExercise={handleExerciseClick} />
      </Box>
    </Box>
  );
};

export default SubjectStatsPage;
